var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTropheeSilver(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B5BAC5;}\r\n\t.st1{fill:#2D3545;}\r\n\t.st2{fill:#474E5E;}\r\n\t.st3{fill:#9CA2B0;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{opacity:0.1;fill:#010101;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.2,121.5v-14.4c0-0.3,0-0.4,0-0.4v-2.2H89.8v2.2c0,0,0,0.1,0,0.4v14.4c0,15.8-8.9,19.4-8.9,19.4h38.1 C119.1,141,110.2,137.4,110.2,121.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.6,
    y: 191.6,
    className: "st1",
    width: 84.9,
    height: 8.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M137.4,186.6H62.6c-2.8,0-5.1,2.3-5.1,5.1v0h84.9v0C142.4,188.8,140.2,186.6,137.4,186.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128.6,151.6H71.4c-4.8,0-8.8,3.9-8.8,8.8v26.2h74.8v-26.2C137.4,155.5,133.4,151.6,128.6,151.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.9,
    y: 141,
    className: "st3",
    width: 38.1,
    height: 5.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.1,20.2V9.5H51.9v10.8H26.3v21.4c0,4.8,0.9,9.5,2.8,13.9c1.8,4.3,4.4,8.1,7.7,11.4 c3.3,3.3,7.1,5.9,11.4,7.7c2.8,1.2,5.7,2,8.7,2.4C64.7,93,81.1,104,100,104h0c18.9,0,35.3-10.9,43.2-26.9c3-0.4,5.9-1.3,8.7-2.4 c4.3-1.8,8.1-4.4,11.4-7.7c3.3-3.3,5.9-7.1,7.7-11.4c1.9-4.4,2.8-9.1,2.8-13.9V20.2H148.1z M35.2,41.7V29.2h16.7v26.7 c0,3.9,0.5,7.6,1.3,11.2C42.7,63.4,35.2,53.4,35.2,41.7z M164.8,41.7c0,11.7-7.5,21.7-18,25.4c0.9-3.6,1.3-7.3,1.3-11.2V29.2h16.7 V41.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M133.4,9.5v41.3c0,26.6-21.5,48.1-48.1,48.1h0c-2.8,0-5.6-0.2-8.2-0.7c6.8,3.7,14.6,5.8,23,5.8h0 c26.6,0,48.1-21.5,48.1-48.1V9.5H133.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M87,100.2v3.8c0,1.5,1.2,2.8,2.8,2.8h20.4c1.5,0,2.8-1.2,2.8-2.8v-3.8H87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.6,0H49.4c-2.6,0-4.7,2.1-4.7,4.7l0,0c0,2.6,2.1,4.7,4.7,4.7h101.1c2.6,0,4.7-2.1,4.7-4.7l0,0 C155.3,2.1,153.2,0,150.6,0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M58,3.4h-7.8c-0.8,0-1.4,0.6-1.4,1.4s0.6,1.4,1.4,1.4H58c0.8,0,1.4-0.6,1.4-1.4S58.7,3.4,58,3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M67.6,3.4h-2.7c-0.8,0-1.4,0.6-1.4,1.4s0.6,1.4,1.4,1.4h2.7c0.8,0,1.4-0.6,1.4-1.4S68.3,3.4,67.6,3.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.3,146.7H77.7c-2.7,0-4.8,2.2-4.8,4.8v0h54.2v0C127.1,148.9,124.9,146.7,122.3,146.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M127.9,154v8.6c0,9.7-7.9,17.6-17.6,17.6H62.6v-19.9c0-4.8,3.9-8.8,8.8-8.8h56.2 C127.8,152.3,127.9,153.2,127.9,154z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.9,
    y: 9.5,
    className: "st5",
    width: 96.2,
    height: 5.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.6,174v-9.9c-1.5,0-2.7-1.2-2.7-2.7H84.1c0,1.5-1.2,2.7-2.7,2.7v9.9c1.5,0,2.7,1.2,2.7,2.7h31.7 C115.9,175.2,117.1,174,118.6,174z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 116.1,
    cy: 169.1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 83.9,
    cy: 169.1,
    r: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTropheeSilver);
export default __webpack_public_path__ + "static/media/trophee-silver.69e22ac6d2b2ec22832f3810f13971e6.svg";
export { ForwardRef as ReactComponent };